"use client"
import Link from "next/link";
import { useEffect, useState } from "react";

function Banners() {
    const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % bannerItems.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

    return (  
        // <div className="bg-white relative py-10 w-full h-[40vh]">
        //   <img src={bannerItems[currentSlide].img} alt="" className="w-full h-full object-cover" />
        // </div>
        <Link href="/shop">
            <img src={bannerItems[currentSlide].img} alt="" className="w-full" />
        </Link>
    );
}

export default Banners;


const bannerItems = [
    {
      title: "CO2 saved",
      value: "30%",
      img: "/banner-img2.png",
    },
    {
      title: "Energy generated",
      value: "25,000 kWh",
      img: "/banner-img1.png",
    },
    {
      title: "Energy saved",
      value: "10,000 kWh",
      img: "/banner-img3.png",
    },
    {
      title: "Energy efficiency improvement",
      value: "26%",
      img: "/banner-img4.png",
    },
  ];